import React, { Component } from "react";
import { Button, Modal, Icon } from "antd";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import {
  validatePendingAuthOrders,
  getNextOrder,
  getPreviousOrder,
  putOrderOnHold,
  setActiveTabKey,
  fetchPendingOrders,
} from "../../../home/homeActions";
import { getUserType } from "../../../../app/common/util/genericUtils";

const orderFormSelector = formValueSelector("orderForm");

class ValidateButtonSet extends Component {
  state = {};
  handleValidate = (data) => {
    const { validatePendingAuthOrders, details } = this.props;
    data["product_group_owner"] = this.props.productGroupOwner;
    validatePendingAuthOrders(details.id, data);
  };
  handleValidateWithoutLensware = (data) => {
    const { validatePendingAuthOrders, details } = this.props;
    data["product_group_owner"] = this.props.productGroupOwner;
    Modal.confirm({
      className: "vwl-confirm-modal",
      icon: <Icon type="warning" theme="filled" className="vwl-confirm-icon" />,
      title: <span className="vwl-confirm-title">Validate Without Lensware</span>,
      content: (
        <div className="vwl-confirm-content">
          <p>
            This order will be validated <strong>without Lensware</strong>.
          </p>
          <ul>
            <li>
              <strong>No VCA file</strong> will be created for this order.
            </li>
            <li>
              The order will <strong>not be processed in Lensware</strong>.
            </li>
          </ul>
          <p className="vwl-confirm-question">Are you sure you want to proceed?</p>
        </div>
      ),
      okText: "Proceed",
      okType: "danger",
      cancelText: "Cancel",
      width: 460,
      onOk: () => {
        validatePendingAuthOrders(details.id, {
          ...data,
          is_lensware: false,
        });
      },
    });
  };
  handleBtnDisable = () => {
    const {
      invalid,
      rightEyeCheckbox,
      leftEyeCheckbox,
      formRightEye,
      formLeftEye,
    } = this.props;

    // Prefer reducer flags, but fall back to form `re`/`le` when they drift
    // (e.g. after resetFields cleared orderForm while initialValues still checked).
    const hasRight = rightEyeCheckbox === true || formRightEye === true;
    const hasLeft = leftEyeCheckbox === true || formLeftEye === true;

    if (!hasRight && !hasLeft) {
      return true;
    } else {
      if (invalid === true) {
        return true;
      } else {
        return false;
      }
    }
  };
  render() {
    const {
      handleSubmit,
      orderId,
      putOnHoldLoader,
      putOrderOnHold,
      getNextOrder,
      getPreviousOrder,
      details,
      fetchPendingOrders,
      type,
      style,
      showNextPrevious,
      showValidateWithoutLensware,
    } = this.props;
    let disabled = this.handleBtnDisable();
    console.log(orderId, type);
    const showWithoutLensware =
      showValidateWithoutLensware === true && getUserType() !== "Customer";
    return (
      <div className="order-form-actions" style={style ? style : { marginBottom: "2%" }}>
        <div className="validate-actions-row" style={{ position: "relative", marginTop: "4%" }}>
          {showWithoutLensware && (
            <div
              className="validate-actions-left"
              style={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              <Button
                type="danger"
                disabled={disabled}
                onClick={handleSubmit(this.handleValidateWithoutLensware)}
              >
                Validate Without Lensware
              </Button>
            </div>
          )}
          <div className="validate-actions-center" style={{ textAlign: "center" }}>
            <Button
              type="primary"
              disabled={disabled}
              onClick={handleSubmit(this.handleValidate)}
              style={{ marginRight: "2%" }}
            >
              Validate Order
            </Button>
            <Button
              type="primary"
              disabled={disabled}
              onClick={() => {
                putOrderOnHold(details.id);
                fetchPendingOrders();
              }}
              loading={putOnHoldLoader}
            >
              Put On Hold
            </Button>
          </div>
        </div>
        {type === "validate" && showNextPrevious && showNextPrevious === true && (
          <div style={{ textAlign: "right", marginTop: "2%" }}>
            <Button
              type="primary"
              style={{ marginRight: "7%" }}
              onClick={() => getPreviousOrder(details.status)}
            >
              Previous
            </Button>
            <Button type="primary" onClick={() => getNextOrder(details.status)}>
              Next
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const actions = {
  validatePendingAuthOrders,
  getNextOrder,
  getPreviousOrder,
  putOrderOnHold,
  setActiveTabKey,
  fetchPendingOrders,
};
const mapStateToProps = (state) => ({
  orderId: state.home.orderDetails.id,
  putOnHoldLoader: state.home.putOnHoldLoader,
  rightEyeCheckbox: state.orderForm.rightEyeCheckbox,
  leftEyeCheckbox: state.orderForm.leftEyeCheckbox,
  formRightEye: orderFormSelector(state, "right_lens_config.re"),
  formLeftEye: orderFormSelector(state, "left_lens_config.le"),
});
export default connect(
  mapStateToProps,
  actions
)(ValidateButtonSet);
